import { defineStore } from 'pinia';
import {
  getStandardDayByEmployeeId,
  StandardDayData,
} from '@/lib/request/webapp/people/leave/get-standard-day';
import formatInputNumberWithTwoDecimals from '@/modules/people/store/leave-standard-hours/format-input-number-with-two-decimals';

type LeaveStandardDayState = {
  standardDayObj: StandardDayData | undefined;
  // the avgHoursPerDay value that's being edited in the UI as opposed to the value that was read from the backend
  avgHoursPerDay: number;
};

const useLeaveStandardHoursStore = defineStore(
  'webapp:people:leave-standard-hours',
  {
    state: (): LeaveStandardDayState => ({
      standardDayObj: undefined,
      avgHoursPerDay: 0,
    }),
    actions: {
      async fetchStandardDayObjByEmployeeId(
        employeeId: number | string
      ): Promise<void> {
        try {
          this.setStandardDayObj(await getStandardDayByEmployeeId(employeeId));
        } catch (e) {
          console.error(e);
          throw new Error(e as string);
        }
      },
      getStandardDayObj(): StandardDayData {
        return this.standardDayObj as StandardDayData;
      },
      isSetStandardDayObj(): boolean {
        return this.getStandardDayObj() !== undefined;
      },
      setStandardDayObj(standardDayObj: StandardDayData | undefined): void {
        this.standardDayObj = standardDayObj;
      },
      getStandardDayHours(): StandardDayData['standardDayHours'] {
        const formatedStandardDayHours = parseFloat(
          String(this.standardDayObj?.standardDayHours ?? 0)
        ).toFixed(2);
        return Number(formatedStandardDayHours);
      },
      getStandardDayCalcMethod(): StandardDayData['standardDayCalcMethod'] {
        return this.standardDayObj?.standardDayCalcMethod || '';
      },
      getDefaultStandardDayHours(): StandardDayData['defaultStandardDayHours'] {
        const formatedDefaultStandardDayHours = formatInputNumberWithTwoDecimals(
          this.standardDayObj?.defaultStandardDayHours
        );
        return Number(formatedDefaultStandardDayHours);
      },
      setAvgHoursPerDay(hours: number): void {
        this.avgHoursPerDay = hours;
      },
      getAvgHoursPerDay(): number {
        return this.avgHoursPerDay;
      },
    },
  }
);

export default useLeaveStandardHoursStore;
